<div class="login-title-section mb-2">
  <fgbcl-errors></fgbcl-errors>
</div>

<div class="form-group mb-2 mt-4 mt-lg-0">
  <button
    (click)="loginTM()"
    class="btn btn-black btn-block login-button font-size-14 w-100 fw-bold"
  >
    <span>{{ 'tm.login.button' | translate }}</span>
    <img [src]="'logos/ticketmaster.svg' | contentAssetImage" alt="Ticketmaster" style="height: 18px;" />
  </button>
</div>
